import { useContext, useState } from 'react';
import { makeStyles, Button } from '@material-ui/core';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import AuthContext from 'contexts/AuthContext';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'center',
  },
  headerRoot: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#f5f5f5',
    padding: '8px 0',
    borderBottom: '1px solid #e0e0e0',
  },
  button: {
    backgroundColor: '#FF8121',
    color: 'white',
    '&:hover': {
      backgroundColor: '#e67312',
    },
  },
  headerButton: {
    backgroundColor: '#FF8121',
    color: 'white',
    fontSize: '14px',
    padding: '6px 16px',
    '&:hover': {
      backgroundColor: '#e67312',
    },
  },
  copied: {
    backgroundColor: '#28a745',
    '&:hover': {
      backgroundColor: '#218838',
    },
  },
});

interface ReferralLinkProps {
  variant?: 'default' | 'header';
}

export const ReferralLink = ({ variant = 'default' }: ReferralLinkProps) => {
  const { user } = useContext(AuthContext);
  const [copied, setCopied] = useState(false);
  const classes = useStyles();

  if (!user) {
    return null;
  }

  const userLink = `${window.location.origin}/${encodeURIComponent(
    user.name,
  )}/`;

  const handleCopy = () => {
    navigator.clipboard.writeText(userLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const isHeader = variant === 'header';

  return (
    <div className={isHeader ? classes.headerRoot : classes.root}>
      <Button
        variant="contained"
        className={`${isHeader ? classes.headerButton : classes.button} ${
          copied ? classes.copied : ''
        }`}
        onClick={handleCopy}
        startIcon={<FileCopyIcon />}
      >
        {copied ? 'Referral Link Copied to Clipboard!' : 'Share Referral Link'}
      </Button>
    </div>
  );
};
